import React from 'react';
import { Alert, Button, Card, Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import dateFormat from 'dateformat';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  DedicatedChannelOrdersTable,
  DidOrdersTable,
  SharedChannelOrdersTable,
  UsedProfilesOrderTable,
} from '@components/Order/Details';
import { Page404, Page500 } from '@containers/ErrorPages';
import { orderApi } from '@reducers/order';

export const Details = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { data, isLoading, isFetching, isError } = orderApi.useGetDetailsQuery({
    uuid,
  });

  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  if (!data) {
    return <Page404 />;
  }
  const date = new Date(data.date_commit);

  return (
    <>
      <Card>
        <Card.Header className="bg-didxl text-white">
          {data.cancellation ? <b>[CANCELLATION]</b> : null} Order{' '}
          {data.reference_number} - {dateFormat(date, 'defaultDateTime')} -{' '}
          <Button variant="didxl" size="sm" style={{ pointerEvents: 'none' }}>
            {data.status ? data.status : null}
          </Button>
        </Card.Header>
        <Card.Body>
          {data.message ? (
            <Alert variant="warning">{data.message}</Alert>
          ) : null}
          {data.didorders.length !== 0 ? (
            <>
              <span>DID Order list</span>
              <div>
                <DidOrdersTable data={data.didorders} />
              </div>
            </>
          ) : null}
          {data.dedicated_channelorders.length !== 0 ? (
            <>
              <span>Dedicated Channel Order list</span>
              <DedicatedChannelOrdersTable
                data={data.dedicated_channelorders}
              />
            </>
          ) : null}
          {data.shared_channelorders.length !== 0 ? (
            <>
              <span>Shared Channel Order list</span>
              <SharedChannelOrdersTable data={data.shared_channelorders} />
            </>
          ) : null}
          {data.profiles.length !== 0 ? (
            <>
              <hr />
              End users used:
              <UsedProfilesOrderTable data={data.profiles} />
            </>
          ) : null}
          <Row>
            <Col className="text-end">Total price: {data.price}</Col>
          </Row>
        </Card.Body>
      </Card>
      <Button
        className="mt-2"
        variant="didxl"
        size="sm"
        style={{ minWidth: '100px' }}
        onClick={() => navigate('/order/open')}
      >
        Exit
      </Button>
    </>
  );
};
